// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a0cff6f","455":"81f688df"}[chunkId] + ".chunk.js";
};